// src/campaigns/engine/campaign-date.utils.ts

export function toISODate(date: Date): string {
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function fromISODate(value: string): Date {
  const [year, month, day] = value.split("-").map(Number);

  if (!year || !month || !day) {
    throw new Error(`Invalid ISO date: ${value}`);
  }

  return new Date(year, month - 1, day);
}

export function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function differenceInCalendarDays(a: Date, b: Date): number {
  const start = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const end = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.round((start - end) / 86_400_000);
}

export function isISODate(value: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(value);
}

export function getNthWeekdayOfMonth(
  year: number,
  monthIndex: number,
  weekday: number,
  occurrence: number
): Date {
  const firstDay = new Date(year, monthIndex, 1);
  const firstWeekdayOffset = (7 + weekday - firstDay.getDay()) % 7;

  return new Date(year, monthIndex, 1 + firstWeekdayOffset + (occurrence - 1) * 7);
}

export function getLastWeekdayOfMonth(year: number, monthIndex: number, weekday: number): Date {
  const lastDay = new Date(year, monthIndex + 1, 0);
  const offset = (7 + lastDay.getDay() - weekday) % 7;

  return new Date(year, monthIndex, lastDay.getDate() - offset);
}

export function getSecondSundayOfMay(year: number): string {
  return toISODate(getNthWeekdayOfMonth(year, 4, 0, 2));
}

export function getThirdSundayOfJune(year: number): string {
  return toISODate(getNthWeekdayOfMonth(year, 5, 0, 3));
}

export function getFirstSundayOfSeptember(year: number): string {
  return toISODate(getNthWeekdayOfMonth(year, 8, 0, 1));
}

export function getFourthThursdayOfNovember(year: number): string {
  return toISODate(getNthWeekdayOfMonth(year, 10, 4, 4));
}

export function getLastSundayOfJuly(year: number): string {
  return toISODate(getLastWeekdayOfMonth(year, 6, 0));
}
